export default "__VITE_PUBLIC_ASSET__6e134721__"